import { render, staticRenderFns } from "./DAUser.vue?vue&type=template&id=6b392b31&scoped=true"
import script from "./DAUser.vue?vue&type=script&lang=js"
export * from "./DAUser.vue?vue&type=script&lang=js"
import style0 from "./DAUser.vue?vue&type=style&index=0&id=6b392b31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b392b31",
  null
  
)

export default component.exports